// GamesHub (admin) — per-game tunables.
//
// 2026-05-16 (Routing Restructure): URL prefix moved from `/games/*`
// to `/settings/games/*`. The legacy `/games` and `/games/:gameId`
// paths redirect into here. Old top-level `/:gameId` aliases continue
// to redirect into `/settings/games/:gameId` via LegacyGameRedirect
// in App.tsx.
//
// Tabs: one per registered game. The default landing /settings/games
// shows the games-list grid (GamesListPanel).

import TabHub, { type TabDef } from '@baaligames/shared-ui/admin/components/TabHub';
import { GAMES } from '@baaligames/shared-ui/games/registry';

// GM-4: Football & Tennis ride the shared cricket engine but are their own
// admin game tabs (own settings + dashboard, sport-scoped). They are NOT in
// the shared-ui registry (that also drives the agent end, which folds sports
// into one Games tab) — so we append them here, admin-only.
const API_SPORT_TABS: TabDef[] = [
  { to: '/settings/games/football', label: 'Football', icon: 'sports_soccer', matchPrefix: '/settings/games/football' },
  { to: '/settings/games/tennis', label: 'Tennis', icon: 'sports_tennis', matchPrefix: '/settings/games/tennis' },
];

export default function GamesHub() {
  const tabs: TabDef[] = [
    { to: '/settings/games', label: 'All games', icon: 'tune', matchPrefix: undefined },
    ...GAMES.map((g) => ({
      to: `/settings/games/${g.id}`,
      label: g.displayName,
      icon: g.adminIcon || 'sports_esports',
      matchPrefix: `/settings/games/${g.id}`,
    })),
    ...API_SPORT_TABS,
  ];
  return (
    <TabHub
      title="Games"
      titleIcon="sports_esports"
      subtitle="Per-game tunables — bet limits, bot behaviour, recovery rules (fees & rebate live in Settings → Rebate)"
      tabs={tabs}
    />
  );
}
